<template>
    <span>{{price}}</span>
</template>

<script>
    /* eslint-disable camelcase */

    export default {
        props: {
            payGrade: {
                type: Object,
                required: true,
            },
        },

        computed: {
            price() {
                if (!this.payGrade) {
                    return null;
                }

                const {
                    starting_price,
                    type,
                } = this.payGrade;

                const prefix = type === 'hourly' ? 'pr. time' : 'pr. stk.'; // TODO: translate?

                return `${type === 'hourly' ? '' : 'fra '}${this.$n(starting_price, 'currency')} ${prefix}`;
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/skills/components/Price.vue